import React from 'react';
import PropTypes from 'prop-types';
import Error404Page from 'src/pages/404Page';
import useRoles from 'src/hooks/useRoles';
import { intersection } from 'lodash';
import AvailableRoles from './AvailableRoles';

function ProtectedPage({ accessRoles, children }) {
  const userRoles = useRoles();

  const commonRoles = intersection(userRoles, accessRoles);

  if (commonRoles.length === accessRoles.length) {
    return children;
  }

  return <Error404Page />;
}

ProtectedPage.propTypes = {
  accessRoles: PropTypes.arrayOf(PropTypes.oneOf(AvailableRoles)).isRequired,
  children: PropTypes.node.isRequired,
};

export default ProtectedPage;
